import { RG49 } from "./ComparativeMonthlySales/RG49";
import { RG63 } from "./ComparativeMonthlySalesDrugstoreChains/RG63";
import { RG42 } from "./ProductSalesGrowthPerformance/RG42";
import { RG64 } from "./ProductSalesByChannelPESO/RG64";
import { RG65 } from "./ProductSalesByCustomerGroupPESO/RG65";

export const RegionComparativeSales = {
  "sections": [
    RG49,
    RG63,
    RG42,
    RG64,
    RG65
  ]
}